<template>
    <div v-wechat-title="title">
        <crud-facecade ref="shiftUserGroup_list" :url="url" :columns="columnList" :buttons="buttons"
            v-wechat-title="title" :tableHeight="tableHeight" :searchLocal="false"
            :addButton="{ enabled: true, permission: 'shiftUserGroup_dic:create' }"
            :updateButton="{ enabled: true, permission: 'shiftUserGroup_dic:edit' }"
            :deleteButton="{ enabled: true, permission: 'shiftUserGroup_dic:delete' }">
            <template slot="filter-after">
                <el-button type="primary" size="mini" @click="refreshList()" title="刷新当前页面">刷新<i
                        class="el-icon--right"></i></el-button>
            </template>
        </crud-facecade>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `ShiftUserGroup`,
    props: {},
    data() {
        return {
            title: `排班分组`,
            currentPage: 1,
            users: [],
            dicSchedule: [],
            pageSize: 50,
            total: 0,
            url: {
                baseURL: `/api/AcisSystem/ShiftUserGroup`,
                get: () => {
                    return new Promise(resolve => {
                        let req = this.myaxios.get(`/api/AcisSystem/ShiftUserGroup/Get`)
                        req.then(data => {
                            console.log(data)
                            resolve(data)
                        })
                    })
                },
                post: data => {
                    let that = this
                    let newData = { ...data }
                    if (data.shiftGroupUserarr && Array.isArray(data.shiftGroupUserarr)) {
                        newData.shiftGroupUsers = data.shiftGroupUserarr.map(item => item.value)
                    }
                    // 修改前效验
                    return that.checkValidate(true, newData)
                },
                put: data => {
                    let that = this
                    let newData = { ...data }
                    if (data.shiftGroupUserarr && Array.isArray(data.shiftGroupUserarr)) {
                        newData.shiftGroupUsers = data.shiftGroupUserarr.map(item => item.value)
                    }

                    // 修改前效验
                    return that.checkValidate(false, newData)
                }
            },
            buttons: []
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.initData()
    },
    computed: {
        ...mapGetters([`sysuser/workers`, `permissions`, `section_auth`, `sys_enums`, `screenHeight`, `ward_auth`, `currentUser`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 190) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `180`,
                    isListable: true,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    readonly: false,
                    sortable: true,
                    isDisplayOrder: true
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `组名`,
                    width: `180`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `bool`,
                    prop: `is_multi_duty`,
                    label: `多次排班`,
                    width: `70`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: false,
                    options: `enum_bool`,
                    default: 1,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `bool`,
                    prop: `status_b`,
                    label: `状态`,
                    width: `70`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: false,
                    options: `is_used`,
                    default: 1,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `multiselect`,
                    prop: `relScheduleShiftUsers`,
                    label: `所属排班`,
                    width: `180`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    options: this.dicSchedule,
                    showCount: 3,
                    collapseTags: false
                },
                {
                    type: `colorpicker`,
                    prop: `back_color`,
                    label: `颜色`,
                    width: `70`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true
                    // colspan: 12
                },
                {
                    type: `multiselect`,
                    prop: `dicWardIds`,
                    label: `所属区域`,
                    width: `180`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: this[`ward_auth`],
                    showCount: 3,
                    collapseTags: false
                },
                {
                    type: `multiselect`,
                    prop: `dicSectionIds`,
                    label: `科室`,
                    width: `180`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    options: this[`section_auth`],
                    showCount: 3,
                    collapseTags: false
                },
                {
                    type: `remotemultiselect`,
                    prop: `shiftGroupUserarr`,
                    label: `组员`,
                    width: `180`,
                    isListable: false,
                    isEditable: true,
                    isCreatable: true,
                    showCount: 300,
                    collapseTags: false,
                    colspan: 24,
                    options: `/api/AcisSystem/Worker/SearchForKey`
                },
                {
                    type: `string`,
                    prop: `creator`,
                    label: `创建人`,
                    isListable: true,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    searchable: false
                },
                {
                    type: `datetime`,
                    prop: `create_dt`,
                    label: `创建时间`,
                    isListable: true,
                    isEditable: false,
                    isCreatable: false
                }
            ]
        }
    },
    mounted() { },
    methods: {
        checkValidate(isAdd, newData) {
            let that = this
            let userIds = newData.shiftGroupUsers
            return new Promise((resolve, reject) => {
                let req = this.myaxios.post(`/api/AcisSystem/ShiftUserGroup/CheckUserGroup?userGroupId=${isAdd ? -1 : newData.id}`, userIds)
                req.then(msg => {
                    // 修改前效验
                    if (msg !== ``) {
                        this.$confirm(`${msg}，是否继续?`, `提示`, {
                            confirmButtonText: `确定`,
                            cancelButtonText: `取消`,
                            type: `warning`,
                            closeOnClickModal: false
                        }).then(() => {
                            return that.addEdit(isAdd, newData).then(data => {
                                resolve(data)
                            })
                        }).catch(e => { })
                    } else {
                        return that.addEdit(isAdd, newData).then(data => {
                            resolve(data)
                        })
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        addEdit(isadd, newData) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios[isadd ? `post` : `put`](`/api/AcisSystem/ShiftUserGroup/${isadd ? `Post` : `Put`}`, newData)
                req.then(data => {
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        afterUpdate(data) {
            console.log(data)
            this.$root[data.key] = data.value
            console.log(`this.$root.IsWorkerByDuty)=` + this.$root.IsWorkerByDuty)
        },
        initData() {
            return new Promise((resolve, reject) => {
                let req1 = this.myaxios.get(`/api/AcisSystem/Worker/Get`)
                let req2 = this.myaxios.get(`/api/AcisSystem/DicSchedule/Get`)
                this.myaxios
                    .all(req1, req2)
                    .then(([data1, data2]) => {
                        this.users = _.map(data1, d => {
                            return {
                                value: d.id,
                                label: d.name || `--`,
                                disabled: d.is_deleted
                            }
                        })
                        var dataArray = _.map(data2, d => {
                            return {
                                value: d.id,
                                label: d.name || `--`,
                                disabled: !d.status_b
                            }
                        })
                        dataArray.push({
                            value: -1,
                            label: `麻醉护理复苏屏(专用)`,
                            disabled: false
                        })
                        this.dicSchedule = dataArray.sort((a, b) => {
                            // 将 disabled 为 false 的元素排在后面
                            if (a.disabled && !b.disabled) {
                                return 1
                            } else if (!a.disabled && b.disabled) {
                                return -1
                            }
                            // 如果 disabled 相等，则按照 value 属性排序，可以根据需要调整排序条件
                            return a.value - b.value
                        })
                    })
                    .catch(e => {
                        console.log(e)
                        reject(e)
                    })
            })
        },
        refreshList() {
            this.$refs[`shiftUserGroup_list`].ReloadListData()
        },
        reloadListData() {
            this.$refs[`shiftUserGroup_list`].ReloadListData()
        }
    }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Dictionary/Schedule/ShiftUserGroup.vue